<!-- Details Section Starts -->
 <input type="text" id="inputToFocusAt" style="position: absolute; top: 20px; left: 400px; padding: 10px 50px; background-color: yellow; z-index: 9999999; visibility: hidden;"> 
<div class="card" style="padding: 10px;">
  <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseGeneralSection">
    <a class="card-link flex-fill">General
      @if (getPermission('Gen_section')?.required) {
      <span class="required-asterik" style="color: whitesmoke;">*</span>
      }
    </a>
    <i class="fas fa-chevron-up"></i>
  </div>
  <div id="collapseGeneralSection" class="collapse show">
    <div class="card-body-section px-4">

   @if(!reloadSection) {
      <div class="row">


        <div class="col-8">
          <div class="row" [formGroup]="generalForm">
            <!-- ===============================================COLUMN 1 Begins============================================= -->
            <div class="col-4">
              <!-- column 1 -->
              <div class="row">
                @if (getPermission('Gen_rimsId')?.visible && !!getFieldValue(UPGeneralFields.userId)) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row ">
                    <div class="col-3 customLabel">{{UPGeneralFields.userIdDesc}}:
                      @if (getPermission('Gen_rimsId')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                       <ejs-textbox trimOnBlur [readonly]="true"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                      [enabled]="getPermission('Gen_rimsId')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_rimsId')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.userId"
                      [ariaHidden]="true" aria-hidden="false"
                        [placeholder]="UPGeneralFields.userIdDesc"></ejs-textbox>
                        <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_rimsId')?.required && generalForm.controls[UPGeneralFields.userId].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_userId')?.visible) {
                <div class="col-11">
                  <!-- Row 2 Column 2 -->
                  <div class="row ">
                    <div class="col-3 customLabel">{{UPGeneralFields.userNameDesc}}:
                      @if (getPermission('Gen_userId')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                       <ejs-textbox trimOnBlur
                      [enabled]="getPermission('Gen_userId')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_userId')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.userName"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                        [placeholder]="UPGeneralFields.userNameDesc"></ejs-textbox>
                        @if(!(isFormSubmitted && generalForm?.get(UPGeneralFields.userName)?.hasError('pattern'))) {
                          <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_userId')?.required && generalForm.controls[UPGeneralFields.userName].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                        } @else {
                          <div  [ngStyle]="{visibility: isFormSubmitted && generalForm?.get(UPGeneralFields.userName)?.hasError('pattern') ? 'visible' : 'hidden'}" class="field-error"><b>&#64;_-.</b> characters are allowed without spaces
                          </div>
                        }
                        
                    </div>
                  </div>
                </div>
                }
                  @if (getPermission('Gen_lastLogin')?.visible && !!getFieldValue(UPGeneralFields.lastLogin)) {
                <div class="col-11">
                  <!-- Row 2 Column 1 -->
                  <div class="row ">
                    <div class="col-3 customLabel">{{UPGeneralFields.lastLoginDesc}}:
                      @if (getPermission('Gen_lastLogin')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                       <ejs-textbox trimOnBlur
                      [enabled]="getPermission('Gen_lastLogin')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_lastLogin')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.lastLogin"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                        [placeholder]="UPGeneralFields.lastLoginDesc"></ejs-textbox>
                        <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_lastLogin')?.required && generalForm.controls[UPGeneralFields.lastLogin].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_gloablEnable')?.visible) {
                <div class="col-4">
                  <!-- Row 3 Column 1 -->
                  <div class="row ">
                    <div class="col-7 customLabel">
                      <ejs-checkbox #generalEnableCb
                      [disabled]="!getPermission('Gen_gloablEnable')?.enable"
                      [label]="UPGeneralFields.enableDesc"
                      [formControlName]="UPGeneralFields.isEnabled"
                      (change)="onGeneralEnableCheckboxChange($event);"></ejs-checkbox>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_SSO')?.visible) {
                <div class="col-6">
                  <!-- Row 3 Column 2 -->
                  <div class="row ">
                    <div class="col-7 customLabel">
                      <ejs-checkbox
                      [disabled]="!getPermission('Gen_SSO')?.enable || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.isSSO"
                      [label]="UPGeneralFields.isSSODesc"
                      (change)="sectionModified({modified: true, section: UPEnums.GeneralFormData})"></ejs-checkbox>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            <!-- ===============================================COLUMN 2 Begins============================================= -->
            <div class="col-4">
              <!-- column 2 -->
              <div class="row">
                @if (getPermission('Gen_userName')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 2 -->
                  <div class="row ">
                    <div class="col-3 customLabel">{{UPGeneralFields.nameDesc}}:
                      @if (getPermission('Gen_userName')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                       <ejs-textbox trimOnBlur
                      [enabled]="getPermission('Gen_userName')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_userName')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.name"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                        [placeholder]="UPGeneralFields.nameDesc"></ejs-textbox>
                        <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_userName')?.required && generalForm.controls[UPGeneralFields.name].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_startDate')?.visible) {
                  <div class="col-11">
                    <!-- Row 1 Column 4 -->
                    <div class="row ">
                      <div class="col-3 customLabel">{{UPGeneralFields.startDateDesc}}:
                        @if (getPermission('Gen_startDate')?.required) {
                        <span class="required-asterik">*</span>
                        }
                      </div>
                      <div class="col-9">
                        <ejs-datepicker [min]="todayDate" [value]="todayDate"
                        [allowEdit]="false" [format]="getDateFormat()"
                        [enabled]="getPermission('Gen_startDate')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Gen_startDate')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPGeneralFields.startDate"
                        (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData});setDateToZeroZero($event, UPGeneralFields.startDate);"
                          [placeholder]="UPGeneralFields.startDateDesc"
                          ></ejs-datepicker>
                          <div class="field-error" [ngStyle]="{visibility: checkDatesFor('SD').isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('SD')?.message}}</div>
                      </div>
                    </div>
                  </div>
                  }
                @if (getPermission('Gen_endDate')?.visible) {
                  <div class="col-11">
                    <!-- Row 1 Column 4 -->
                    <div class="row ">
                      <div class="col-3 customLabel">{{UPGeneralFields.endDateDesc}}:
                        @if (getPermission('Gen_endDate')?.required) {
                        <span class="required-asterik">*</span>
                        }
                      </div>
                      <div class="col-9">
                        <ejs-datepicker [min]="generalForm.get(UPGeneralFields.startDate)?.value || todayDate" [value]="todayDate"
                        [allowEdit]="false" [format]="getDateFormat()"
                        [enabled]="getPermission('Gen_endDate')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Gen_endDate')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPGeneralFields.endDate"
                        (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData});setDateToZeroZero($event, UPGeneralFields.endDate);"
                          [placeholder]="UPGeneralFields.endDateDesc" [enabled]="true"
                          ></ejs-datepicker>
                          <div class="field-error" [ngStyle]="{visibility: checkDatesFor('ED')?.isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('ED')?.message}}</div>
                      </div>
                    </div>
                  </div>
                  }
                @if (timeZone) {
                  <div class="col-11">
                    <!-- Time zone (DB-013): the day a DRO reading is recorded on. -->
                    <div class="row ">
                      <div class="col-3 customLabel">Time Zone:</div>
                      <div class="col-9">
                        <select class="form-select form-select-sm up-time-zone" aria-label="Time zone" [disabled]="!isSectionEnabled"
                          (change)="onTimeZoneChange($any($event.target).value)">
                          <option value="" [selected]="!timeZoneValue">Company default ({{ timeZoneLabel(timeZone.companyTimeZoneId) }})</option>
                          @for (z of timeZones; track z.id) {
                            <option [value]="z.id" [selected]="z.id === timeZoneValue">{{ z.displayName }}</option>
                          }
                        </select>
                        <div class="up-time-zone-hint">Today there: {{ timeZone.today }}. Decides the day a DRO reading is recorded on.</div>
                      </div>
                    </div>
                  </div>
                  }
              </div>
            </div>
            <!-- ===============================================COLUMN 3 Begins============================================= -->
            <div class="col-4">
              <!-- column 2 -->
              <div class="row">
                @if (getPermission('Gen_globalMobile')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 2 -->
                  <div class="row ">
                    <div class="col-4 customLabel">{{UPGeneralFields.mobileDesc}}:
                      @if (getPermission('Gen_globalMobile')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur  style="padding-left: 0px; margin-left: 0px;"
                      [enabled]="getPermission('Gen_globalMobile')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_globalMobile')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.primaryMobile"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                        [placeholder]="UPGeneralFields.mobileDesc"></ejs-textbox>
                        @if(isFormSubmitted && getPermission('Gen_globalMobile')?.required && generalForm.controls[UPGeneralFields.primaryMobile].invalid) {
                              <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_globalMobile')?.required && generalForm.controls[UPGeneralFields.primaryMobile].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                            } @else {
                              <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted
                                && (generalForm.controls[UPGeneralFields.primaryMobile].invalid || !isMobileNumberValid)) ? 'visible' : 'hidden'}">Field is Invalid</div>
                            }
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_globalEmail')?.visible) {
                <div class="col-11">
                  <!-- Row 2 Column 2 -->
                  <div class="row ">
                    <div class="col-4 customLabel">{{UPGeneralFields.emailDesc}}:
                      @if (getPermission('Gen_globalEmail')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur="email"
                      [enabled]="getPermission('Gen_globalEmail')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Gen_globalEmail')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPGeneralFields.primaryEmail"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})"
                        [placeholder]="UPGeneralFields.emailDesc"></ejs-textbox>
                        @if(isFormSubmitted && getPermission('Gen_globalEmail')?.required && generalForm.controls[UPGeneralFields.primaryEmail].invalid) {
                          <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_globalEmail')?.required && generalForm.controls[UPGeneralFields.primaryEmail].invalid) ? 'visible' : 'hidden'}">Field is required</div>
                        } @else {
                          <div class="field-error" [ngStyle]="{visibility: (isFormSubmitted
                            && (generalForm.controls[UPGeneralFields.primaryEmail].invalid || !isEmailAddressValid)) ? 'visible' : 'hidden'}">Field is Invalid</div>
                        }
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Gen_globalEmail')?.visible) {
              <div class="col-11">
                <!-- Row 1 Column 4 -->
                <div class="row">
                  <div class="col-4 customLabel">{{UPGeneralFields.countryDesc}}:
                    @if (getPermission('Gen_globalEmail')?.required) {
                    <span class="required-asterik">*</span>
                    }
                  </div>
                  <div class="col-8">
                    <ejs-dropdownlist #countriesDDL [dataSource]="countriesList"
                      [formControlName]="UPGeneralFields.countryId" [title]="countriesDDL.text || 'Select a Country'"
                      [fields]="{ text: 'text', value: 'displayOrder' }"
                      [placeholder]="'Select '+UPGeneralFields.countryDesc"
                      [readonly]="getPermission('Gen_globalEmail')?.readOnly || !isSectionEnabled"
                      [enabled]="getPermission('Gen_globalEmail')?.enable && isSectionEnabled"
                      (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.GeneralFormData})">
                    </ejs-dropdownlist>
                    <div class="field-error"
                      [ngStyle]="{visibility: (isFormSubmitted && getPermission('Gen_globalEmail')?.required && generalForm?.controls[UPGeneralFields.countryId].invalid) ? 'visible' : 'hidden'}">
                      Field is required</div>
                  </div>
                </div>
              </div>
            }
              </div>
            </div>
            
          </div>
        </div>
        <div class="col-4">

          <div class="row">
            <div class="col-7">

                <div class="row signaturePositions">
                  <div class="col-lg-12 d-flex justify-content-center m-0 p-0">Signature</div>
                  <div class="col-lg-12 d-flex justify-content-center">
                    <div class="wrapper signaturePositions" (click)="showEditSignaturePopup = isSignatureEnabled;">
                      <ng-container *ngIf="!signatureImage">
                        <div class="editIconPlaceHolder">
                          <h1 style="font-weight: bolder;
                          font-size: 48px !important;
                          color: black;;">N/A</h1>
                        </div>
                      </ng-container>
                      <!-- <canvas class="" ejs-signature #signature (contextmenu)="$event.preventDefault();"></canvas> -->
                      <img *ngIf="signatureImage" [src]="signatureImage" class="canvas" alt="">
                    </div>
                  </div>
                </div>
                <div class="row pb-3" style="margin-top: 33px;">
                  <div class="col-lg-8 m-auto">
                    <div class="d-flex justify-content-center">
                      <i class="fas fa-pencil del-icon px-2" (click)="showEditSignaturePopup = isSignatureEnabled;" [title]="'Edit Signature'"
                        [ngClass]="{'enabled-icon': isSignatureEnabled, 'disabled-icon': (!getPermission('Gen_editUserSignature')?.enable || (!userId && source === UPEnums.SourceUser) || !isSectionEnabled) }"></i>
                      <i class="fas fa-trash del-icon px-2" (click)="deleteUI('Signature');" [title]="'Delete Signature'"
                        [ngClass]="{'enabled-icon': isSignatureDeletable, 'disabled-icon': (!getPermission('Gen_deleteUserSignature')?.enable || (!userId && source === UPEnums.SourceUser) || !signatureImage || !isSectionEnabled) }"></i>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-5">

              <div class="d-flex justify-content-around align-items-end">
                <div class="image-section" #dropElement>
                  <div class="captions mt-3">Profile Picture</div>
                  @if (INITIALS?.length > 0 && !pictureURL) {
                    <ng-container>
                      <div class="initials" style="font-size: 42px !important;">{{INITIALS}}</div>
                    </ng-container>
                  } @else {
                    <ng-container>
                      <div>
                        <img id="profilePicturePlaceholder" class="rounded"
                          [src]="pictureURL"
                          alt="unsupported image" />
                      </div>
                    </ng-container>
                  }
                  <div class="captions">Drop image files here</div>
                  <input #imageChooser type='file' style="visibility: hidden; position: absolute;" class="image-input"
                    accept=".png,.jpg,.jpeg,.gif,.bmp,.webp,.svg,.tiff,.tif,.heic,.heif" (click)="clickAttachmentUpload($event)" />
                  <div class="image-buttons">
                    <button class="border border-secondary btn btn-sm mt-1 px-3 ms-4 me-1"
                    [disabled]="!getPermission('Gen_addUserProfilePicture')?.enable  || !isSectionEnabled" (click)="imageChooser?.click()">BROWSE...</button>
                    <i class="fas fa-trash del-icon px-2" (click)="deleteUI('Profile Picture')"
                      [ngClass]="{'enabled-icon': isProfilePictureDeletable, 'disabled-icon': (!getPermission('Gen_deleteUserProfilePicture')?.enable  || !pictureURL  || !isSectionEnabled) }"></i>
                  </div>



                  <ejs-uploader #profilePictureUpload
                style="visibility: hidden; position: absolute;"
                    id='profilePictureUpload'
                    [asyncSettings]='path'
                    [dropArea]='dropElement'
                    [maxFileSize]="3.2e+7"
                    (uploading)="beforeFileUpload($event)"
                    (created)="onUploaderCreated(profilePictureUpload)"
                    (success)="onUploadSuccess($event)"
                    (clearing)="onFileClear($event)"
                    (actionComplete)="onActionComplete($event)"
                    ></ejs-uploader>
                </div>
              </div>
             
            </div>
          </div>

        </div>



      </div>

      @if (getPermission('Gen_addressesGrid')?.visible)
      {
        <div class="row">
          <div class="col-10 ">Addresses</div>
          <div class="col-12 addressesGrid">

            @if (userProfile) {
              <div class="w-100 up-addresses-grid">
                @if (addressesGridConfig) {
                <inavista-grid #AddressesGrid
                  [config]="addressesGridConfig"
                  [actionIcons]="addressesActionIcons"
                  (actionIconClick)="onAddressAction($event)"
                  (toolbarActionClick)="onAddressesToolbarAction($event)" />
                }
              </div>
            }
          </div>
        </div>
      }

    }
    @else {
    <div class="profile-skeleton">

  <div class="profile-header">
    <!-- <div class="profile-avatar shimmer"></div> -->

    <div class="profile-details">
      <div class="detail-line large shimmer"></div>
      <div class="detail-line shimmer"></div>
      <div class="detail-line shimmer short"></div>

      <div class="detail-grid">
        <div class="detail-item shimmer" *ngFor="let i of [1,2,3,4]"></div>
      </div>
    </div>
  </div>


  <!-- Table Section -->
  <div class="section">
    <div class="section-title shimmer"></div>
    <div class="table-skeleton">
      <div class="table-row shimmer" *ngFor="let i of [1,2]"></div>
    </div>
  </div>

</div>

<div *ngIf="!isLoading">
  <!-- Real profile content -->
</div>
  
}

    </div>
  </div>
</div>
<!-- Details Section Ends -->

@if (showEditSignaturePopup) {
  <app-signature-popup
  [signatureImage]="signatureImage"
  [isSignatureRequired]="$safeNavigationMigration(this.getPermission('Gen_editUserSignature')?.required)"
  [userId]="userId"
  (onCloseSignaturePopup)="showEditSignaturePopup = false;"
  (onSaveSignaturePopup)="onSaveSignaturePopup($event)"
   ></app-signature-popup>
}


<app-addresses-grid-popup
*ngIf="showAddAddressesPopup"
(onClose)="onAddressesPopupClose($event)"
></app-addresses-grid-popup>

